import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import { Chip, Typography } from "@mui/material";
import useColors from "../../../../../api/hooks/useColors";

export default function SmartFilterButton({
  text,
  selected,
  onClick,
  onRemove,
  disabled = true,
  sx = {},
}) {
  const colors = useColors();
  return (
    <Chip
      onClick={onClick}
      onDelete={onRemove}
      sx={{
        background: colors.grey_50,
        cursor: selected ? "auto" : "pointer",
        height: "32px",
        width: "min-content",
        border: selected
          ? "1px solid " + colors.primary_400
          : "1px solid " + colors.grey_32percent,
        borderRadius: "10px",
        justifyContent: "space-evenly",
        "& .MuiChip-deleteIcon": {
          display: selected ? "inline-block" : "none",
        },
        ...sx,
      }}
      label={
        <Typography
          variant={selected ? "overline" : "caption"}
          color={colors.primary_400}
        >
          {text}
        </Typography>
      }
      disabled={disabled}
      deleteIcon={
        selected ? (
          <CancelRoundedIcon
            style={{
              width: "16px",
              color: colors.primary_48percent,
              cursor: "pointer",
            }}
          />
        ) : null
      }
    />
  );
}
